import React from "react";
import { Button, Flex, Card, Text, OpenOutsideIcon } from "@fluentui/react-northstar";
import { useTools } from "../queries";
import styles from "../common.module.scss";
import ITool from "../interfaces/ITool";

const Tools = () => {
    document.title = "Tools";
    const { data: toolsData } = useTools();
    const tools: ITool[] = toolsData ?? [];

    const openLink = (url: string) => window.open(url, "_blank");

    return (
        <Flex column gap="gap.medium" className={styles.formBody}>
            {tools.map((tool: ITool) => (
                <Card key={tool.title} style={{ width: "100%" }} onClick={() => openLink(tool.link)}>
                    <Card.Header>
                        <Flex column gap="gap.small">
                            <Text content={tool.title} size="large" />
                            <Text content={tool.description} />
                        </Flex>
                    </Card.Header>

                    <Card.Footer fitted>
                        <Flex vAlign="end">
                            <Flex.Item push><div></div></Flex.Item>
                            <Button
                                content="Otevřít"
                                primary icon={<OpenOutsideIcon />}
                                onClick={() => openLink(tool.link)}
                            />
                        </Flex>
                    </Card.Footer>
                </Card>
            ))}
        </Flex>
    );
};

export default Tools;
